// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"efb45e85","146":"2d1dfeac","153":"836a8407","157":"bb50fd68","187":"7e7c8896","203":"efb49618","285":"19ffb1d2","386":"3196965a","453":"ea025e36","556":"eac69b0a","746":"c739faa4","779":"3e467605"}[chunkId] + ".chunk.js";
};